import { Link } from "react-router-dom";
import Reveal from "./Reveal";
import { Star, SunDoodle } from "./Illustrations";
import { Heart } from "./Doodles";

/** Six best lifestyle moments in a single horizontal scroll strip.
 *  Replaces the older 2x5 grid + CustomerMoments grid for a tighter read. */
const SCENES = [
  { src: "/lifestyle/urban/scene-01.jpg", caption: "Jumping for sundown", slug: "coco" },
  { src: "/lifestyle/urban/scene-03.jpg", caption: "Hello hallway", slug: "hola" },
  { src: "/lifestyle/urban/scene-05.jpg", caption: "Sunday sprint", slug: "vamos" },
  { src: "/lifestyle/urban/scene-06.jpg", caption: "Hand on hip", slug: "brio" },
  { src: "/lifestyle/urban/scene-08.jpg", caption: "Spin a song", slug: "lolo" },
  { src: "/lifestyle/urban/scene-10.jpg", caption: "Tiny flower talks", slug: "tico" },
];

export default function InAction() {
  return (
    <section
      className="relative py-16 md:py-24 px-5 md:px-10 bg-[#FAFAF7] overflow-hidden"
      data-testid="in-action"
    >
      <SunDoodle size={44} className="absolute top-12 right-[8%] spin-slow opacity-60 hidden md:block" />
      <Star size={18} className="absolute bottom-16 left-[6%] wiggle" color="#DD2E20" />

      <div className="mx-auto max-w-[1440px]">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-5 mb-8 md:mb-12 px-1">
          <Reveal>
            <div>
              <p className="eyebrow mb-3">Out in the world</p>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-[-0.025em] max-w-[18ch]">
                Same SOL. <span className="italic" style={{ color: "#DD2E20" }}>Different days.</span>
              </h2>
            </div>
          </Reveal>
          <Reveal delay={80}>
            <p className="text-[#595955] max-w-[34ch] text-sm md:text-base flex items-center gap-2">
              <Heart size={14} color="#DD2E20" /> Tag{" "}
              <a
                href="https://instagram.com/solkids_eyewear"
                target="_blank"
                rel="noreferrer"
                className="font-medium text-[#2C2C2A] underline-offset-4 hover:underline"
                data-testid="in-action-instagram-tag"
              >
                @solkids_eyewear
              </a>{" "}
              to be featured.
            </p>
          </Reveal>
        </div>

        {/* Horizontal scroll strip — gentle snapping, natural touch momentum */}
        <Reveal>
        <div
          className="-mx-5 md:-mx-10 px-5 md:px-10 overflow-x-auto snap-x snap-proximity no-scrollbar"
          data-testid="in-action-strip"
        >
          <div className="flex gap-4 md:gap-6 pb-2">
            {SCENES.map((s, i) => (
                <Link
                  key={s.src}
                  to={`/collection/${s.slug}`}
                  className="group relative block snap-start rounded-[22px] overflow-hidden bg-[#F3EADA] lift w-[72vw] sm:w-[44vw] md:w-[300px] lg:w-[340px] shrink-0"
                  data-testid={`in-action-${i}`}
                  data-hover="true"
                >
                  <div className="aspect-[4/5] overflow-hidden">
                    <img
                      src={s.src}
                      alt={`${s.caption} — wearing ${s.slug.charAt(0).toUpperCase() + s.slug.slice(1)} sunglasses`}
                      loading="lazy"
                      className="w-full h-full object-cover group-hover:scale-[1.05] transition-transform duration-[1200ms]"
                      style={{ transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)" }}
                    />
                  </div>
                  <div className="absolute inset-x-3 bottom-3 rounded-xl bg-[#FAFAF7]/95 backdrop-blur px-3 py-2 flex items-center justify-between gap-2">
                    <p className="font-serif text-sm md:text-base leading-tight truncate">{s.caption}</p>
                    <span className="text-[10px] uppercase tracking-[0.15em] text-[#595955] shrink-0">→ {s.slug}</span>
                  </div>
                </Link>
            ))}
          </div>
        </div>
        </Reveal>

        <Reveal delay={200}>
          <p className="mt-6 md:mt-8 text-center text-[11px] text-[#8A8A85] tracking-[0.18em] uppercase">
            Swipe — tap any photo to shop the exact frame
          </p>
        </Reveal>
      </div>
    </section>
  );
}
